const TUI_EXAMPLE_PRIMARY_FILE_NAME = {
    TS: 'TypeScript',
    LESS: 'LESS',
    HTML: 'HTML',
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_EXAMPLE_PRIMARY_FILE_NAME };
